import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';


const Card = styled.a`
  display: block;
  padding: 18px 22px;
  border-radius: 12px;
  background: rgba(255,255,200,0.07);
  border: 1px solid rgba(255,255,255,0.1);
  text-decoration: none;
  backdrop-filter: blur(8px);
  transition: all 0.2s;

  &:hover {
    background: rgba(255,255,255,0.1);
    border-color: rgba(78,95,253,0.25);
    transform: translateY(-2px);
  }
`;

const Badge = styled.div`
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  background: rgba(34,197,94,0.15);
  color: #22c55e;
  display: inline-block;
  margin-bottom: 10px;
`;

const CardTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #FFFFFF
`;

const CardDesc = styled.div`
  font-size: 13px;
  color: rgba(255,255,255,0.65);
`;

export const FeatureCard = ({
    className,
    title,
    description,
    link,
    pillText = 'NEW'
}: FeatureCard.Props): React.ReactElement => (
    <Card className={cx(className)}
        href={link}
        target="_blank"
        rel="noopener noreferrer"
    >
        <Badge>{pillText}</Badge>
        <CardTitle>{title}</CardTitle>
        <CardDesc>
          {description}
        </CardDesc>
    </Card>
);


/* eslint-disable-next-line @typescript-eslint/no-redeclare */
export namespace FeatureCard {
  export interface Props {
    className?: string;
    title: string;
    description: string;
    link?: string;
    pillText?: string;
  }
}
